// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `AutoCompleteTextField.css .react-autocomplete-input {
  background-clip: padding-box;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  bottom: auto;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  display: block;
  font-size: 14px;
  list-style: none;
  padding: 1px;
  position: absolute;
  text-align: left;
  z-index: 20000;
}

.react-autocomplete-input > li {
  cursor: pointer;
  padding: 10px;
  min-width: 100px;
}

.react-autocomplete-input > li.active {
  background-color: #337ab7;
  color: #fff;
}

.p-button {
  color: black !important;
  background-color: transparent !important;
  border: none !important;
}
.p-button.p-button-icon-only {
  padding: 0 !important;
}
button.close {
  line-height: 0.8 !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/ReusuableComponents/AutoCompleteTextField.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,qCAAqC;EACrC,YAAY;EACZ,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B","sourcesContent":["AutoCompleteTextField.css .react-autocomplete-input {\r\n  background-clip: padding-box;\r\n  background-color: #fff;\r\n  border: 1px solid rgba(0, 0, 0, 0.15);\r\n  bottom: auto;\r\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\r\n  display: block;\r\n  font-size: 14px;\r\n  list-style: none;\r\n  padding: 1px;\r\n  position: absolute;\r\n  text-align: left;\r\n  z-index: 20000;\r\n}\r\n\r\n.react-autocomplete-input > li {\r\n  cursor: pointer;\r\n  padding: 10px;\r\n  min-width: 100px;\r\n}\r\n\r\n.react-autocomplete-input > li.active {\r\n  background-color: #337ab7;\r\n  color: #fff;\r\n}\r\n\r\n.p-button {\r\n  color: black !important;\r\n  background-color: transparent !important;\r\n  border: none !important;\r\n}\r\n.p-button.p-button-icon-only {\r\n  padding: 0 !important;\r\n}\r\nbutton.close {\r\n  line-height: 0.8 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
